// /**
//  * Buy Buttons Dynamic Price Updater
//  * Updates the price displayed in the Add to Cart button when quantity changes
//  */

// (function() {
//   'use strict';

//   function formatMoney(cents) {
//     const currencyCodeEnabled = window.themeVariables?.settings?.currencyCodeEnabled || false;
//     let moneyFormat;
    
//     if (currencyCodeEnabled) {
//       moneyFormat = window.themeVariables?.settings?.moneyWithCurrencyFormat || '${{amount}}';
//     } else {
//       moneyFormat = window.themeVariables?.settings?.moneyFormat || '${{amount}}';
//     }
    
//     // Convert cents to currency value
//     const value = (cents / 100).toFixed(2);
//     const valueWithoutDecimals = Math.round(cents / 100).toString();
    
//     // Split into integer and decimal parts
//     const parts = value.split('.');
//     const integerPart = parts[0];
//     const decimalPart = parts[1];
    
//     // Format for different locales
    
//     // Standard format: 1,234.56 (comma as thousands separator, dot as decimal)
//     const integerWithComma = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//     const amount = integerWithComma + '.' + decimalPart;
    
//     // European format: 1.234,56 (dot as thousands separator, comma as decimal)
//     const integerWithDot = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
//     const amountWithCommaSeparator = integerWithDot + ',' + decimalPart;
    
//     // Space as thousands separator with dot decimal: 1 234.56
//     const integerWithSpace = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
//     const amountWithSpaceSeparator = integerWithSpace + decimalPart;
    
//     // No decimals formats
//     const amountNoDecimals = valueWithoutDecimals;
//     const amountNoDecimalsWithComma = valueWithoutDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//     const amountNoDecimalsWithSpace = valueWithoutDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    
//     // Replace all possible Shopify money format placeholders
//     return moneyFormat
//       .replace('{{amount_with_comma_separator}}', amountWithCommaSeparator)
//       .replace('{{amount_no_decimals_with_comma_separator}}', integerWithDot)
//       .replace('{{amount_with_space_separator}}', amountWithSpaceSeparator)
//       .replace('{{amount_no_decimals_with_space_separator}}', amountNoDecimalsWithSpace)
//       .replace('{{amount_no_decimals}}', amountNoDecimals)
//       .replace('{{amount}}', amount);
//   }

//   function updateButtonPrice(buyButtonsElement) {
//     if (!buyButtonsElement) return;
    
//     const formId = buyButtonsElement.getAttribute('form');
//     if (!formId) return;
    
//     const form = document.getElementById(formId);
//     if (!form) return;
    
//     const quantityInput = form.querySelector('input[name="quantity"]') || 
//                          form.querySelector('.quantity-selector__input') ||
//                          document.querySelector(`[form="${formId}"][name="quantity"]`) ||
//                          document.querySelector(`[form="${formId}"].quantity-selector__input`);
    
//     if (!quantityInput) return;
    
//     const quantity = parseInt(quantityInput.value) || 1;
    
//     let basePriceElement = buyButtonsElement.querySelector('[data-base-price]');
//     let totalPriceElement = buyButtonsElement.querySelector('[data-total-price]');
    
//     if (!basePriceElement || !totalPriceElement) {
//       const allBasePriceElements = document.querySelectorAll('[data-base-price]');
//       const allTotalPriceElements = document.querySelectorAll('[data-total-price]');
      
//       if (!basePriceElement) {
//         basePriceElement = form.querySelector('[data-base-price]');
        
//         if (!basePriceElement) {
//           const wrapper = buyButtonsElement.closest('.product-info-atc-qty-wrapper');
//           if (wrapper) {
//             basePriceElement = wrapper.querySelector('[data-base-price]');
//           }
//         }
        
//         if (!basePriceElement && allBasePriceElements.length > 0) {
//           basePriceElement = allBasePriceElements[0];
//         }
//       }
      
//       if (!totalPriceElement) {
//         totalPriceElement = form.querySelector('[data-total-price]');
        
//         if (!totalPriceElement) {
//           const wrapper = buyButtonsElement.closest('.product-info-atc-qty-wrapper');
//           if (wrapper) {
//             totalPriceElement = wrapper.querySelector('[data-total-price]');
//           }
//         }
        
//         if (!totalPriceElement && allTotalPriceElements.length > 0) {
//           totalPriceElement = allTotalPriceElements[0];
//         }
//       }
//     }
    
//     if (!basePriceElement || !totalPriceElement) return;
    
//     const basePrice = parseInt(basePriceElement.getAttribute('data-base-price'));
//     const totalPrice = basePrice * quantity;
//     const formattedPrice = formatMoney(totalPrice);
    
//     totalPriceElement.textContent = formattedPrice;
//   }

//   function initAll() {
//     const allBuyButtons = document.querySelectorAll('buy-buttons');
//     allBuyButtons.forEach(buyButtons => {
//       updateButtonPrice(buyButtons);
//     });
//   }

//   function setupGlobalListener() {
//     document.addEventListener('change', function(event) {
//       const target = event.target;
      
//       const isQuantityByName = target && target.name === 'quantity';
//       const isQuantityByClass = target && target.classList.contains('quantity-selector__input');
      
//       if (isQuantityByName || isQuantityByClass) {
//         let form = target.form;
        
//         if (!form && target.hasAttribute('form')) {
//           const formAttr = target.getAttribute('form');
//           form = document.getElementById(formAttr);
//         }
        
//         if (!form) {
//           form = target.closest('form');
//         }
        
//         if (form) {
//           const formId = form.id;
//           let buyButtons = document.querySelector(`buy-buttons[form="${formId}"]`);
          
//           if (!buyButtons) {
//             const wrapper = target.closest('.product-info-atc-qty-wrapper');
//             if (wrapper) {
//               buyButtons = wrapper.querySelector('buy-buttons');
//             }
//           }
          
//           if (!buyButtons) {
//             const allBuyButtons = document.querySelectorAll('buy-buttons');
//             for (let bb of allBuyButtons) {
//               if (bb.getAttribute('form') === formId) {
//                 buyButtons = bb;
//                 break;
//               }
//             }
//           }
          
//           if (buyButtons) {
//             updateButtonPrice(buyButtons);
//           }
//         }
//       }
//     }, true);
//   }

//   function init() {
//     setupGlobalListener();
//     initAll();
    
//     setTimeout(initAll, 100);
//     setTimeout(initAll, 500);
//     setTimeout(initAll, 1000);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
  
// })();
/**
 * Buy Buttons Dynamic Price Updater
 * Updates the price displayed in the Add to Cart button when quantity changes
 */

(function() {
  'use strict';

  function formatMoney(cents) {
    const currencyCodeEnabled = window.themeVariables?.settings?.currencyCodeEnabled || false;
    let moneyFormat;
    
    if (currencyCodeEnabled) {
      moneyFormat = window.themeVariables?.settings?.moneyWithCurrencyFormat || '${{amount}}';
    } else {
      moneyFormat = window.themeVariables?.settings?.moneyFormat || '${{amount}}';
    }
    
    // Convert cents to currency value
    const value = (cents / 100).toFixed(2);
    const valueWithoutDecimals = Math.round(cents / 100).toString();
    
    // Split into integer and decimal parts
    const parts = value.split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];
    
    // Format for different locales
    
    // Standard format: 1,234.56 (comma as thousands separator, dot as decimal)
    const integerWithComma = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amount = integerWithComma + '.' + decimalPart;
    
    // European format: 1.234,56 (dot as thousands separator, comma as decimal)
    const integerWithDot = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const amountWithCommaSeparator = integerWithDot + ',' + decimalPart;
    
    // Space as thousands separator with dot decimal: 1 234.56
    const integerWithSpace = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const amountWithSpaceSeparator = integerWithSpace + decimalPart;
    
    // No decimals formats
    const amountNoDecimals = valueWithoutDecimals;
    const amountNoDecimalsWithComma = valueWithoutDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountNoDecimalsWithSpace = valueWithoutDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    
    // Replace all possible Shopify money format placeholders
    return moneyFormat
      .replace('{{amount_with_comma_separator}}', amountWithCommaSeparator)
      .replace('{{amount_no_decimals_with_comma_separator}}', integerWithDot)
      .replace('{{amount_with_space_separator}}', amountWithSpaceSeparator)
      .replace('{{amount_no_decimals_with_space_separator}}', amountNoDecimalsWithSpace)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  function updateButtonPrice(buyButtonsElement) {
    if (!buyButtonsElement) return;
    
    const formId = buyButtonsElement.getAttribute('form');
    if (!formId) return;
    
    const form = document.getElementById(formId);
    if (!form) return;
    
    const quantityInput = form.querySelector('input[name="quantity"]') || 
                         form.querySelector('.quantity-selector__input') ||
                         document.querySelector(`[form="${formId}"][name="quantity"]`) ||
                         document.querySelector(`[form="${formId}"].quantity-selector__input`);
    
    if (!quantityInput) return;
    
    const quantity = parseInt(quantityInput.value) || 1;
    
    let basePriceElement = buyButtonsElement.querySelector('[data-base-price]');
    let totalPriceElement = buyButtonsElement.querySelector('[data-total-price]');
    
    if (!basePriceElement || !totalPriceElement) {
      const allBasePriceElements = document.querySelectorAll('[data-base-price]');
      const allTotalPriceElements = document.querySelectorAll('[data-total-price]');
      
      if (!basePriceElement) {
        basePriceElement = form.querySelector('[data-base-price]');
        
        if (!basePriceElement) {
          const wrapper = buyButtonsElement.closest('.product-info-atc-qty-wrapper');
          if (wrapper) {
            basePriceElement = wrapper.querySelector('[data-base-price]');
          }
        }
        
        if (!basePriceElement && allBasePriceElements.length > 0) {
          basePriceElement = allBasePriceElements[0];
        }
      }
      
      if (!totalPriceElement) {
        totalPriceElement = form.querySelector('[data-total-price]');
        
        if (!totalPriceElement) {
          const wrapper = buyButtonsElement.closest('.product-info-atc-qty-wrapper');
          if (wrapper) {
            totalPriceElement = wrapper.querySelector('[data-total-price]');
          }
        }
        
        if (!totalPriceElement && allTotalPriceElements.length > 0) {
          totalPriceElement = allTotalPriceElements[0];
        }
      }
    }
    
    if (!basePriceElement || !totalPriceElement) return;
    
    const basePrice = parseInt(basePriceElement.getAttribute('data-base-price'));
    const totalPrice = basePrice * quantity;
    const formattedPrice = formatMoney(totalPrice);
    
    totalPriceElement.textContent = formattedPrice;
  }

  function initAll() {
    const allBuyButtons = document.querySelectorAll('buy-buttons');
    allBuyButtons.forEach(buyButtons => {
      updateButtonPrice(buyButtons);
    });
  }

  function setupGlobalListener() {
    document.addEventListener('change', function(event) {
      const target = event.target;
      
      const isQuantityByName = target && target.name === 'quantity';
      const isQuantityByClass = target && target.classList.contains('quantity-selector__input');
      
      if (isQuantityByName || isQuantityByClass) {
        let form = target.form;
        
        if (!form && target.hasAttribute('form')) {
          const formAttr = target.getAttribute('form');
          form = document.getElementById(formAttr);
        }
        
        if (!form) {
          form = target.closest('form');
        }
        
        if (form) {
          const formId = form.id;
          let buyButtons = document.querySelector(`buy-buttons[form="${formId}"]`);
          
          if (!buyButtons) {
            const wrapper = target.closest('.product-info-atc-qty-wrapper');
            if (wrapper) {
              buyButtons = wrapper.querySelector('buy-buttons');
            }
          }
          
          if (!buyButtons) {
            const allBuyButtons = document.querySelectorAll('buy-buttons');
            for (let bb of allBuyButtons) {
              if (bb.getAttribute('form') === formId) {
                buyButtons = bb;
                break;
              }
            }
          }
          
          if (buyButtons) {
            updateButtonPrice(buyButtons);
          }
        }
      }
      
      // Listen for variant changes
      const isVariantSelect = target && (target.name === 'id' || target.classList.contains('variant-select'));
      if (isVariantSelect) {
        initAll();
      }
    }, true);
    
    // Listen for variant update events (for themes that use custom events)
    document.addEventListener('variant:change', function() {
      initAll();
    });
  }

  function init() {
    setupGlobalListener();
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
